import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import colors from '@/styles/color.scss';
let BodyAttributeRecognition = class BodyAttributeRecognition extends Vue {
    disabled;
    value;
    activeColor = colors.searchYellow;
    inactiveColor = colors.inputBorder;
    iconFontSize = `fontSize:1.5rem`;
    get status() {
        return this.value;
    }
    set status(val) {
        this.$emit('input', val);
    }
    get statusText() {
        return this.status ? this.$t('active') : this.$t('inactive');
    }
    swichChange(val) {
        this.$emit('change', val);
    }
};
__decorate([
    Prop({ default: false, type: Boolean })
], BodyAttributeRecognition.prototype, "disabled", void 0);
__decorate([
    Prop({ default: true, type: Boolean })
], BodyAttributeRecognition.prototype, "value", void 0);
BodyAttributeRecognition = __decorate([
    Component({
        name: 'BodyAttributeRecognition',
        components: {},
        i18n: {
            messages: {
                en: {
                    title: 'Body Attribute Recognition',
                    active: 'Activated',
                    inactive: 'Inactivated',
                    mobodyAttributedeTip: 'Turn off the button and the digital human will present a generic human model；Turn on the button, and the digital human will present different mannequins by gender',
                },
                zh: {
                    title: '人体属性识别',
                    active: '启用',
                    inactive: '停用',
                    mobodyAttributedeTip: '关闭该按钮，数字人将呈现通用人体模型。打开该按钮，数字人将按性别呈现不同的人体模型',
                },
            },
        },
    })
], BodyAttributeRecognition);
export default BodyAttributeRecognition;
